import React, { Component } from 'react';
import './AdminEditCourierData.css';
import personlg from '../../../../image/personlg.svg'
import iconpen from '../../../../image/iconpen.svg'

class AdminEditCourierData extends Component {

    render() {
        return (
            <div className="EditFAQ">
                <div className="row ">

                    <div className="col-11 row">
                        <p className="col-lg-8 col-md-10  mt-1 ml-1 p-0 fontsize10  "><img className="iconsm" src={personlg} alt="user kayn" />

                            {this.props.state.objectClient.name}

                        </p>
                        <div className=" col-md-2 custom-control custom-switch text-center">
                            <input type="checkbox" className="custom-control-input" id="customSwitch1" checked={(this.props.state.online === true ? 'checked' : '')} />
                            <label className="custom-control-label" htmlFor="customSwitch1" onClick={this.props.handleOnline}></label>
                        </div>
                        <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                            {this.props.state.onlineError}
                        </div>
                        <div className="col-md-8 d-sm-flex justify-content-sm-between">
                            <p className="fontsize12 text-muted ">Member since May 00,0000 </p>
                            <p className="fontsize12 text-muted ">Completed services: 000</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-9 mb-3 shadow text-center p-3 bg-white  ">
                    <p className="fontsize12">
                        CURRENT BALANCE
                    </p>
                    <p className="fontsize10 bluecolor">{this.props.state.balance} EGP</p>
                    <div className="form-group">
                        <label className="form-check-label fontsize11 " >amount</label>
                        <input type="number" className="form-control col-md-6 mx-auto my-2 badge-pill" placeholder="Amount EGP" name="amount" value={this.props.state.amount} onChange={this.props.handleChange} />
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.amountError}
                        </div>
                        <button onClick={this.props.updatecourierbalance} className="btn badge-pill p-2 pl-1 px-3 my-2 m-1 border shadow bg-white " >Confirm</button>
                    </div>
                </div>
                <p className="col-md-6 mt-2 px-2 fontsize4 font-weight-bold ">Contact details</p>
                <hr />
                <div className="form-group col-lg-6 col-md-12 col-sm-6">
                    <p className="fontsize12 text-muted">Full Name</p>
                    <p className="fontsize4 ">{this.props.state.objectClient.name}</p>
                </div>
                <div className="form-group col-lg-6 col-md-12 col-sm-6">
                    <p className="fontsize12 text-muted">Phone number</p>
                    <p className="fontsize4 ">{this.props.state.objectClient.phone}</p>
                </div>
                {/* <p className="fontsize12  mt-4">City</p>
               <div className="form-check mx-3">
                    <input className="form-check-input" type="radio" name="gridRadios" id="gridRadios1" value="option1" checked />
                    <label className="form-check-label fontsize5" htmlFor="gridRadios1">
                    cairo
                    </label>
                </div>
                <div className="form-check mx-3">
                    <input className="form-check-input" type="radio" name="gridRadios" id="gridRadios1" value="option1" checked />
                    <label className="form-check-label fontsize5" htmlFor="gridRadios1">
                    cairo
                    </label>
                </div> */}

                <p className="fontsize12  mt-4">Courier type</p>
                <div className="form-check mx-3">
                    <input className="form-check-input" type="radio" name="title" id="PICKER" value="pickup" onClick={this.props.handleType} checked={(this.props.state.title === "pickup" ? 'checked' : '')} />
                    <label className="form-check-label fontsize5" htmlFor="PICKER">
                        PICKER
                    </label>
                </div>
                <div className="form-check mx-3">
                    <input className="form-check-input" type="radio" name="title" id="SHIPPER" value="delivery" onClick={this.props.handleType} checked={(this.props.state.title === "delivery" ? 'checked' : '')} />
                    <label className="form-check-label fontsize5" htmlFor="SHIPPER">
                        SHIPPER
                    </label>
                </div>
                <div style={{ fontSize: 12, color: "red", textAlign: "center" }}>
                    {this.props.state.titleError}
                </div>
                <button onClick={this.props.editcourier} className="btn badge-pill p-2 pl-1 px-3 my-2 m-1 border shadow bg-white " ><img className="mr-1" src={iconpen} alt="pen" />SAVE EDIT </button>
                {/* <button className="btn badge-pill p-2 pl-1 px-4  m-1 border shadow  bg-white  " >CANCEL</button>
                    <button className="btn badge-pill p-2 pl-1 px-3 m-1 border shadow bg-danger text-white " ><img className="mr-1 " src={closeicon} alt="" />DELETE</button> */}

               
            </div>
        )
    }
}
export default AdminEditCourierData;